<form [formGroup]="form" (ngSubmit)="submit()">
  <div class="display-flex align-items-center">
    <h2 mat-dialog-title>{{ isEditMode ? 'Edit' : 'Add' }} board</h2>
    <app-radio-button-dropdown
      class="flex-grow-1 layout-type"
      [containerCss]="'w-100'"
      [items]="boardLayoutTypeList"
      [attrDisable]="!!data?.id"
      formControlName="boardLayoutType"
      [allowClear]="false"
      [allowSearch]="false"
      [autoSortList]="false"
      [showValidationError]="false"
      [optionCss]="'inspection-format-option'"
      attrAppendTo="body"></app-radio-button-dropdown>
  </div>

  <mat-dialog-content [class.fade-bottom]="isEditMode && isSettingsOpened && (scrollToBottom$ | async) > 30">
    <div
      class="form"
      appScroll
      [class.scrollable-content]="isEditMode && isSettingsOpened"
      (scrollToBottom)="scrollToBottom$.next($event)">
      <div class="grid">
        <app-radio-button-dropdown
          [valueCss]="'pre-title fs s14'"
          formControlName="boardType"
          [items]="boardTypeList"
          [allowClear]="false"
          [label]="'Type'"
          [attrAppendTo]="'body'"
          [attrDisable]="!!data?.id"
          [errorSection]="false"></app-radio-button-dropdown>
        <app-input
          [labelCss]="'nowrap pre-label'"
          [attrPlaceholder]="'Board name...'"
          formControlName="name"
          [attrLabel]="'Name'"
          [errorSection]="false"></app-input>
      </div>

      <div class="grid" *ngIf="form.get('boardLayoutType')?.value === BoardLayoutType.ProjectsBoard">
        <div class="display-flex flex-column position-relative" style="margin-top: -20px">
          <app-radio-button-dropdown
            [valueCss]="'pre-title fs s14'"
            formControlName="projectTypes"
            [items]="projectTypes$ | async"
            [multiSelect]="true"
            [allowClear]="false"
            [labelRequired]="true"
            [label]="'Auto-add Project of these types to board'"
            [attrAppendTo]="'body'"
            [errorSection]="false"></app-radio-button-dropdown>
          <div class="fs s14 button-text create-project" (click)="createProject()">Add a new Project type</div>
        </div>
      </div>

      <div class="text-centered">
        <button class="fs s14 button-text" (click)="toggleAdvancedSettings()" type="button">Advanced settings</button>
      </div>

      <div class="advanced-settings-wrapper" [ngClass]="{ 'is-open': isSettingsOpened }">
        <div class="advanced-settings">
          <div class="grid">
            <app-radio-button-dropdown
              [valueCss]="'pre-title fs s14'"
              formControlName="selectedPortfolioIds"
              [items]="userPortfolios"
              [allowClear]="false"
              [label]="'Portfolio association'"
              [multiSelect]="true"
              [allowSelectAll]="true"
              [allPropertiesLabel]="true"
              allPropertiesPlaceholder="All Portfolios"
              [attrAppendTo]="'body'"
              [errorSection]="false"></app-radio-button-dropdown>

            <app-radio-button-dropdown
              [valueCss]="'pre-title fs s14'"
              formControlName="excludedPropertyIds"
              [items]="propertyList"
              [allowClear]="false"
              [label]="'Excluded Properties'"
              [attrPlaceholder]="'Select properties'"
              [multiSelect]="true"
              [attrAppendTo]="'body'"
              [errorSection]="false"></app-radio-button-dropdown>

            <div
              style="grid-column: span 2"
              *ngIf="form.get('boardLayoutType')?.value !== BoardLayoutType.ProjectsBoard">
              <div class="w-50 pr8">
                <app-radio-button-dropdown
                  [valueCss]="'pre-title fs s14'"
                  formControlName="showArchivedTurnovers"
                  [items]="booleanListConst"
                  [allowClear]="false"
                  [label]="'Include Archived turns'"
                  [attrAppendTo]="'body'"
                  [errorSection]="false"></app-radio-button-dropdown>
              </div>
            </div>

            <app-radio-button-dropdown
              [valueCss]="'pre-title fs s14'"
              formControlName="defaultScheduleDynamicTicketTypeId"
              [items]="dynamicTicketTypeList"
              [allowClear]="false"
              [label]="'Default Ticket type for Schedule'"
              [attrAppendTo]="'body'"
              [errorSection]="false"></app-radio-button-dropdown>

            <app-radio-button-dropdown
              [valueCss]="'pre-title fs s14'"
              formControlName="defaultCostDynamicTicketTypeId"
              [items]="dynamicTicketTypeList"
              [allowClear]="false"
              [label]="'Default Ticket type for Cost column'"
              [attrAppendTo]="'body'"
              [errorSection]="false"></app-radio-button-dropdown>

            <div
              style="grid-column: span 2"
              class="display-flex grid-gap-12"
              [class.flex-row-item]="form.get('boardLayoutType')?.value === BoardLayoutType.ProjectsBoard">
              <div
                class="w-50"
                [ngClass]="{ pr8: form.get('boardLayoutType')?.value !== BoardLayoutType.ProjectsBoard }">
                <app-radio-button-dropdown
                  [valueCss]="'pre-title fs s14'"
                  formControlName="poNumberIsAvailable"
                  [items]="pmNumberBehaviorList"
                  [allowClear]="false"
                  [label]="'PO number'"
                  [attrAppendTo]="'body'"
                  [errorSection]="false"></app-radio-button-dropdown>
              </div>
            </div>

            <ng-container *ngIf="form.get('boardLayoutType')?.value !== BoardLayoutType.ProjectsBoard">
              <app-radio-button-dropdown
                [valueCss]="'pre-title fs s14'"
                formControlName="datasource"
                [items]="boardSourceTypeList"
                [allowClear]="false"
                [label]="'Start with Units in'"
                [attrAppendTo]="'body'"
                [attrDisable]="!!data?.id"
                [errorSection]="false"></app-radio-button-dropdown>

              <app-radio-button-dropdown
                [valueCss]="'pre-title fs s14'"
                formControlName="outputAction"
                [items]="boardOutputTypeList"
                [allowClear]="false"
                [label]="'End by sending turn to'"
                [attrAppendTo]="'body'"
                [errorSection]="false"></app-radio-button-dropdown>
            </ng-container>

            <!-- Remaining fields -->
            <div
              *ngIf="form.get('boardLayoutType')?.value !== BoardLayoutType.ProjectsBoard"
              style="grid-column: span 2">
              <div class="w-50 pr8">
                <app-radio-button-dropdown
                  [valueCss]="'pre-title fs s14'"
                  formControlName="sendBackBehaviour"
                  [items]="sendBackBehaviourList"
                  [allowClear]="false"
                  [label]="'When unit moved back to board'"
                  [attrAppendTo]="'body'"
                  [errorSection]="false"></app-radio-button-dropdown>
              </div>
            </div>

            <app-radio-button-dropdown
              *ngIf="form.get('boardLayoutType')?.value !== BoardLayoutType.ProjectsBoard"
              [valueCss]="'pre-title fs s14'"
              formControlName="progressType"
              [items]="progressTypeList"
              [allowClear]="false"
              [label]="'Update progress bar in'"
              [attrAppendTo]="'body'"
              [labelRequired]="true"
              [errorSection]="false"></app-radio-button-dropdown>

            <ng-container *ngIf="form.get('boardLayoutType')?.value !== BoardLayoutType.ProjectsBoard">
              <ng-container *ngTemplateOutlet="removeRowsTpl"></ng-container>
            </ng-container>
            <ng-template #removeRowsTpl>
              <app-radio-button-dropdown
                *ngIf="form.get('boardLayoutType')?.value !== BoardLayoutType.ProjectsBoard"
                [valueCss]="'pre-title fs s14'"
                formControlName="outputBehaviour"
                [items]="boardOutputBehaviorList"
                [allowClear]="false"
                [label]="'Remove rows'"
                [attrAppendTo]="'body'"
                [errorSection]="false"></app-radio-button-dropdown>
            </ng-template>
            <div
              class="send-projects-to-archive"
              *ngIf="form.get('boardLayoutType')?.value === BoardLayoutType.ProjectsBoard">
              <mat-checkbox
                [checked]="form.get('outputAction')?.value === BoardOutputType.SendToArchive"
                (change)="onOutputChange($event)">
                Send project to Archive when all steps are done
              </mat-checkbox>
            </div>
          </div>

          <app-custom-color-picker
            [labelCss]="'nowrap pre-label'"
            [valueCss]="'pre-title fs s14'"
            formControlName="boardCellColor"
            [containerCss]="'display-flex flex-column grid-gap-12'"
            [label]="'Cell color'"></app-custom-color-picker>

          <form
            *ngIf="!!groupsArray.controls && isEditMode"
            class="form-groups"
            [class.groups]="groupsArray.controls?.length"
            [formGroup]="boardGroupForm">
            <div class="groups-title">Column groups</div>

            <div formArrayName="groups">
              <div *ngFor="let group of groupsArray.controls; let i = index" [formGroupName]="i" class="grid">
                <app-input
                  [labelCss]="'nowrap pre-label'"
                  [attrPlaceholder]="'Group name...'"
                  formControlName="name"
                  [attrLabel]="'Name'"
                  [errorSection]="false"></app-input>

                <app-radio-button-dropdown
                  [valueCss]="'pre-title fs s14'"
                  formControlName="cols"
                  [items]="colOptions"
                  [allowClear]="false"
                  [label]="'Columns'"
                  [multiSelect]="true"
                  [attrAppendTo]="'body'"
                  [errorSection]="false"></app-radio-button-dropdown>

                <app-custom-color-picker
                  [labelCss]="'nowrap pre-label'"
                  [valueCss]="'pre-title fs s14'"
                  formControlName="colorBg"
                  [containerCss]="'display-flex flex-column grid-gap-12'"
                  [label]="'Header color'"></app-custom-color-picker>

                <app-custom-color-picker
                  [labelCss]="'nowrap pre-label'"
                  [valueCss]="'pre-title fs s14'"
                  formControlName="colorText"
                  [containerCss]="'display-flex flex-column grid-gap-12'"
                  [label]="'Text color'"></app-custom-color-picker>

                <button class="remove-icon" (click)="removeGroup(i)">Remove group</button>
              </div>
            </div>

            <div class="add-group" (click)="addNewGroup()">
              <app-icon [iconWidth]="16" [iconHeight]="16" [svg]="EIcon.PLUS_FULL"></app-icon>
              <span>New group</span>
            </div>
          </form>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="actions">
    <div class="display-flex grid-gap-8 justify-content-space-between w-100">
      <button mat-stroked-button color="warn" class="modal-button" (click)="close()" type="button">Cancel</button>
      <button mat-raised-button color="primary" class="modal-button" type="submit" [disabled]="inProgress$ | async">
        <div class="display-flex align-items-center justify-content-center grid-gap-6">
          {{ isEditMode ? 'Save' : 'Add' }}
          <mat-spinner *ngIf="inProgress$ | async" color="accent" diameter="20"></mat-spinner>
        </div>
      </button>
    </div>
  </mat-dialog-actions>
</form>
